<template>
	<el-header style="text-align: right; font-size: 12px">
		<el-menu  
			mode="horizontal"
			background-color="#545c64ad"
			text-color="#fff"
			active-text-color="#ffd04b">
			<el-menu-item index="0" @click="toggle()"><i class="fa fa-exchange fa-2x"></i></el-menu-item>
			<el-menu-item index="1" @click="desconectar" class="menu__custom">Desconectar</el-menu-item>
		</el-menu>
	</el-header>
</template>
<script>
import { LOGOUT } from "@/store/actions.type";
  export default {
    computed: {
      routeName () {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      }
    },
    data () {
      return {
        activeNotifications: false
      }
    },
    methods: {
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      desconectar() {
          this.$store.dispatch(LOGOUT).then(() => {
              this.$router.push({ name: "Login" });
          });
	  },
	  toggle() {
		  this.$root.$emit("toogleChange", true);
	  }
    }
  }

</script>
<style lang="scss" scoped>
	.el-header {
		padding: 0;
		.menu__custom {
			float: right;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/TopNavbar.vue